
import {Vue, Component, Prop} from "vue-property-decorator";

@Component({
  name: "CrossRegionMenu"
})
export default class CrossRegionMenu extends Vue {
  private width = 200;
  private height = 200;
  @Prop({type: Array}) readonly center!: Array<number>;

  get left() {
    return this.center[0] - this.width / 2;
  }

  get top() {
    return this.center[1] - this.height / 2;
  }
}
